import { Controller } from "stimulus"

export default class extends Controller {
  public connect(): void {
    window.NProgress.configure({ parent: `#${this.element.id}` })
  }
}
